// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group .hidden {
  width: 0;
  margin: 0;
  border: none;
  padding: 0;
}

.custom-day {
  text-align: center;
  padding: 0.185rem 0.25rem;
  display: inline-block;
  height: 2rem;
  width: 2rem;
}
.custom-day :focus {
  outline: none !important;
}

.custom-day.focused {
  background-color: #e6e6e6;
}

.custom-day.range, .custom-day:hover {
  background: linear-gradient(180deg, rgb(0, 237, 228) 15%, rgb(40, 148, 189) 100%);
  color: white;
  border: none;
}

.custom-day.faded {
  background: linear-gradient(180deg, rgba(0, 237, 228, 0.5) 15%, rgba(40, 148, 189, 0.5) 100%);
  color: #000;
}

.date-label {
  margin-top: 12px !important;
  padding-right: 20px;
}

.primary {
  margin-left: 10px !important;
}

.calendar-button {
  background: transparent;
  border: none;
  cursor: pointer;
  margin-top: 7px;
  margin-left: 0px;
}
.calendar-button :focus {
  outline: none !important;
}

.mat-icon {
  font-size: 2.3vh;
}

*:focus {
  outline: none !important;
}

.input-group {
  margin-top: 2px;
}

.date-end-group {
  margin-left: 20px;
}

.clear-button {
  margin: 1px 3px -7 0 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
